import { toKeyAsIdAndValueAsLabel } from './generalHelpers.js'

export const roles = {
  ADMIN: 'Admin',
  USER: 'User',
  API_USER: 'API User'
}

export const rolesMap = toKeyAsIdAndValueAsLabel(roles)

export default roles
